import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  Clinicrequestlist,
  createAgencyDoctor,
  FetchDegreetType,
  FetchLanguage,
  FetchMODALITIES,
  FetchPopulationServed,
  GetAgencyBooking,
  GetCategory,
  GetConditionTreated,
  GetDeliveryMode,
  GetInsurance,
  GetProviderType,
  GetServiceParactiseaddress,
  GetSpecialties,
  uploadImage,
} from "../../../api/helper";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Autocomplete, useLoadScript } from "@react-google-maps/api";
import moment from "moment";
import { ShowToast } from "../../../helpers/ToastService";
import {
  DropDownManuCustom,
  DropDownManuCustomMulti,
} from "../../Components/DropDownButton";
import Inputbox from "../../Components/Inputbox";
import { Dropdowniconn } from "../../assest/SvgImages";
import { Modal } from "@mui/material";
import { Box } from "lucide-react";
import timezones from "timezones-list";

const eighteenYearsAgo = new Date();
eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

const validationSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("First Name is required")
    .min(2, "First Name must be at least 2 characters"),

  lastName: Yup.string()
    .required("Last Name is required")
    .min(2, "Last Name must be at least 2 characters"),

  email: Yup.string()
    .email("Enter a valid email")
    .required("Email is required"),
  phone: Yup.string().required("Phone number is required"),
  DOB: Yup.date()
    .typeError("Date of Birth must be a valid date")
    .required("Date of Birth is required")
    .max(eighteenYearsAgo, "You must be at least 18 years old")
    .test(
      "notToday",
      "Date of Birth cannot be today's date",
      (value) => value && value < new Date().setHours(0, 0, 0, 0)
    ),
  experience: Yup.string().required("Experience is required"),
  ProviderNPI: Yup.string()
    .required("Provider NPI is required")
    .matches(/^[0-9]{10}$/, "Provider NPI must be 10 digits"),
  categoryId: Yup.array()
    .of(Yup.string().required("A Specialities must be selected"))
    .min(1, "At least one Specialities is required")
    .required("Specialty is required"),

  info: Yup.string().required("Info is required"),
  gender: Yup.string().required("Please select a gender"),
  LanguagesId: Yup.array()
    .of(Yup.string().required("A language must be selected"))
    .min(1, "At least one language is required")
    .required("language is required"),
  ProviderHomeAddress: Yup.string().required(
    "Provider Home Address is required"
  ),
  // primaryStateOfPractice: Yup.string().required(
  //   "Primary State of Practice is required"
  // ),
  address: Yup.object().shape({
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    zipCode: Yup.string()
      .required("Zip code is required")
      .matches(/^[0-9]+$/, "Zip code must be digits")
      .min(5, "Zip code must be at least 5 digits")
      .max(10, "Zip code cannot exceed 10 digits"),
  }),
});
const Locationdata = timezones.map((tz) => ({
  name: tz.label,
}));
const days = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const AddProviderpopupagency = ({ onClose }) => {
  const navigate = useNavigate();
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  // console.log(profiledata._id,'===profiledata')

  const [specialtydata, setspecialtydata] = useState(null);
  const [imaeg, setImages] = useState(null);
  const fileInputRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [cliniclistdata, setcliniclistdata] = useState(null);
  const [showavailibleday, setShowavailibleday] = useState(false);
  const [availableDays, setAvailableDays] = useState([]);
  const { isLoading } = useSelector((store) => store.sliceReducer);
  const [autocomplete, setAutocomplete] = useState(null);
  const [Specialties, setSpecialties] = useState();
  const [Treatment, setTreatment] = useState([]);
  const [deleveryMode, setDeleveryMode] = useState([]);
  const [Insurance, setInsurance] = useState([]);
  const [PopulationServed, setPopulationServed] = useState();
  const [Modalities, setModalities] = useState();
  const [servicelocation, setservicelocation] = useState([]);
  const [providerType, setproviderType] = useState([]);
  const [conditionTreated, setConditionTreated] = useState([]);
  const [Degreetypedata, setDegreetypedata] = useState([]);
  const [data, setdata] = useState([]);
  const [addressAutocomplete, setAddressAutocomplete] = useState(null);
  const [weeklySchedule, setWeeklySchedule] = useState(
    days.reduce((acc, day) => {
      acc[day] = [];
      return acc;
    }, {})
  );

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyAoF8F2jhZ_6-77oYJi0hgGTbcVh-CCIEE",
    libraries: ["places"],
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const handleChange = (e) => {
    setValue("phone", e);
  };
  const handleSelect = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);

    setValue("categoryId", ids, { shouldValidate: true });
  };
  const handlePlaceSelect = async () => {
    const place = autocomplete.getPlace();
    const addressComponents = place.address_components;

    const getAddressComponent = (type) => {
      const component = addressComponents.find((c) => c.types.includes(type));
      return component ? component.long_name : "";
    };

    setValue("address.country", getAddressComponent("country"));
    setValue(
      "address.state",
      getAddressComponent("administrative_area_level_1")
    );
    setValue("address.city", getAddressComponent("locality"));

    const streetNumber = getAddressComponent("street_number");
    const route = getAddressComponent("route");
    const sublocality = getAddressComponent("sublocality");
    const neighborhood = getAddressComponent("neighborhood");
    const premise = getAddressComponent("premise");
    const establishment = getAddressComponent("establishment");

    let fullStreet = "";

    if (establishment) {
      fullStreet = establishment;
    } else if (premise) {
      fullStreet = `${premise}, ${route || sublocality || neighborhood}`;
    } else if (streetNumber && route) {
      fullStreet = `${streetNumber} ${route}`;
    } else if (sublocality) {
      fullStreet = sublocality;
    } else if (neighborhood) {
      fullStreet = neighborhood;
    }

    if (!fullStreet) {
      fullStreet = `${getAddressComponent("locality")}, ${getAddressComponent(
        "administrative_area_level_1"
      )}, ${getAddressComponent("country")}`;
    }

    setValue("address.street", fullStreet);

    setValue("address.zipCode", getAddressComponent("postal_code"));
  };
  const handleAddressSelection = () => {
    const selectedPlace = addressAutocomplete.getPlace();
    // if (selectedPlace.formatted_address) {
    //   setAddress(selectedPlace.formatted_address);
    // }
  };
  const Fetchclinic = async () => {
    try {
      const response = await Clinicrequestlist();
      const data = response?.data?.data?.data?.map((e) => {
        return {
          name: `${e.companyName} / ${e.uniqueId}`,
          ...e,
        };
      });
      setcliniclistdata(data);
    } catch (error) {
      console.log(error);
    }
  };
  const GetSpecialtiesList = async () => {
    try {
      const response = await GetSpecialties(`?id=${profiledata?._id}`);
      setSpecialties(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const getModalities = async () => {
    try {
      const response = await FetchMODALITIES(`?id=${profiledata?._id}`);
      setModalities(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const PopulationServedGet = async () => {
    const response = await FetchPopulationServed(`?id=${profiledata?._id}`);
    setPopulationServed(response?.data?.data);
  };

  const InsuranceType = async () => {
    try {
      const response = await GetInsurance(`?id=${profiledata?._id}`);
      let resData = response?.data?.data;
      resData = resData?.map((e) =>
        e.adminInsurenceId ? { ...e, name: e.adminInsurenceId.PayerName } : e
      );
      setInsurance(resData);
    } catch (error) {
      console.log(error, "===e");
    }
  };
  const TreatmentTypeslist = async () => {
    try {
      const response = await GetAgencyBooking(`?id=${profiledata?._id}`);
      setTreatment(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const DeliveryMode = async () => {
    try {
      const response = await GetDeliveryMode(`?id=${profiledata?._id}`);
      setDeleveryMode(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchAddresslist = async (id) => {
    try {
      const response = await GetServiceParactiseaddress(profiledata?._id);
      setservicelocation(
        Array.isArray(response?.data?.data?.data)
          ? response?.data?.data?.data
          : []
      );
      // setservicelocation(response);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchProviderType = async (id) => {
    const response = await GetProviderType(`?id=${profiledata?._id}`);
    setproviderType(response?.data?.data || []);
  };

  const fetchConditionTreated = async (id) => {
    const response = await GetConditionTreated(`?id=${profiledata?._id}`);
    setConditionTreated(response?.data?.data || []);
  };
  const GetDegreetype = async (id) => {
    const response = await FetchDegreetType(`?id=${profiledata?._id}`);
    setDegreetypedata(response?.data?.data);
  };
  const GetLanguage = async (id) => {
    const response = await FetchLanguage(`?id=${profiledata?._id}`);
    setdata(response?.data?.data);
  };
  useEffect(() => {
    GetLanguage();
    GetDegreetype();
    fetchConditionTreated();
    FetchAddresslist();
    Fetchclinic();
    InsuranceType();
    PopulationServedGet();
    TreatmentTypeslist();
    GetSpecialtiesList();
    getSpecialty();
    DeliveryMode();
    getModalities();
    fetchProviderType();
  }, []);

  const getSpecialty = async () => {
    try {
      const resposne = await GetCategory();
      setspecialtydata(resposne?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleavailibledays = () => {
    setShowavailibleday(true);
  };

  const imagePicker = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("images", file);
      try {
        const response = await uploadImage(formData);
        setImages(response.data.data[0].URL);
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
      } catch (error) {
        console.log(error, "===");
      }
    }
  };
  const clickImageData = () => {
    // console.log(fileInputRef, "click=====");
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  console.log(availableDays, "availableDays=-=-");
  const onSubmit = async (data) => {
    if (availableDays.length === 0) {
      return ShowToast("Please select Available Days", "error");
    }
    // data.availableDays = availableDays;
    data.EnumerationDate = moment(data.EnumerationDate).format("YYYY-MM-DD");
    data.DOB = moment(data.DOB).format("YYYY-MM-DD");
    if (imaeg) {
      data.image = imaeg;
    }
    data = {
      ...data,
      availableDays,
      agencyId: profiledata._id,
    };
    console.log(data, "data=-=-=");
    try {
      const response = await createAgencyDoctor(data);
      ShowToast(response.data.message, "success");
      reset();
      onClose();
      //   navigate(-1);
    } catch (error) {
      console.log(error, "===error");
    }
  };

  const options = [
    { _id: "0-1", name: "0-1 (New or Entry Level)" },
    { _id: "2-5", name: "2-5 (Early Career)" },
    { _id: "6-10", name: "6-10 (Experienced)" },
    { _id: "11-15", name: "11-15 (Advanced)" },
    { _id: "16-20+", name: "16-20+ (Expert or Senior Level)" },
  ];

  const selectSpecialties = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("Specialties", ids, { shouldValidate: true });
  };
  const selectModalities = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("Modalities", ids, { shouldValidate: true });
  };
  const selectPopulationServed = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("PopulationServed", ids, { shouldValidate: true });
  };
  const selectInsurance = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("Insurance", ids, { shouldValidate: true });
  };
  const selectTreatmentType = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("ServiceType", ids, { shouldValidate: true });
  };

  const selectDeliveryMode = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("DeliveryMode", ids, { shouldValidate: true });
  };

  const handleSelectProviderType = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("ProviderType", ids, { shouldValidate: true });
  };
  const handleSelectConditionTreated = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("ConditionTreatedId", ids, { shouldValidate: true });
  };
  const handleSelectdegreetype = (selectedOptions) => {
    let ids = selectedOptions.map((e) => e?._id);
    setValue("degreeTypeId", ids, { shouldValidate: true });
  };
  const handlelanguage = (selectedOptions) => {
    let ids = selectedOptions?.map((e) => e?._id);
    setValue("LanguagesId", ids, { shouldValidate: true });
  };
  if (!isLoaded) return <div>Loading...</div>;
  const onError = (errors) => {
    console.log("Validation Errors:", errors);
  };
const toMinutes = (time) => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

const hasOverlap = (blocks) => {
  const sorted = [...blocks].sort((a, b) => toMinutes(a.start) - toMinutes(b.start));
  for (let i = 0; i < sorted.length - 1; i++) {
    const currentEnd = toMinutes(sorted[i].end);
    const nextStart = toMinutes(sorted[i + 1].start);
    if (currentEnd > nextStart) {
      return true; // Overlap found
    }
  }
  return false;
};
const addTimeBlock = (day) => {
  const updated = { ...weeklySchedule };
  updated[day].push({ start: "09:00", end: "17:00" });
  setWeeklySchedule(updated);
};

const handleTimeBlockChange = (day, index, field, value) => {
  const updated = { ...weeklySchedule };
  updated[day][index][field] = value;
  setWeeklySchedule(updated);
};


  const removeTimeBlock = (day, index) => {
    const updated = { ...weeklySchedule };
    updated[day].splice(index, 1);
    setWeeklySchedule(updated);
  };



const handleSaveSettings = () => {
  for (const [day, blocks] of Object.entries(weeklySchedule)) {
    if (hasOverlap(blocks)) {
      alert(`Overlapping time blocks found on ${day}. Please fix them.`);
      return;
    }
  }

  const formattedData = Object.entries(weeklySchedule)
    .filter(([_, shifts]) => shifts.length > 0)
    .map(([day, shifts]) => ({
      day,
      shifts: shifts.map((shift) => ({
        startTime: shift.start,
        endTime: shift.end,
      })),
    }));

  setAvailableDays(formattedData);
  console.log("Formatted Data:", formattedData);
  setShowavailibleday(false);
};

  return (
    <div className="review-popup-overlay">
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <div
          className="review-popup-container_three"
          style={{
            paddingLeft: 40,
            paddingRight: 40,
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <div className="service_rating_txt" style={{}}>
            Add Provider
          </div>
          <div className="textttttttt" style={{ marginLeft: 10 }}>
            A notification inviting the member to join the practice will be
            sent.
          </div>
          <div className="provider-form-container">
            <div className="form-header">
              <div className="profile-image">
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    style={{
                      height: 130,
                      width: 130,
                      marginLeft: 20,
                      borderRadius: 60,
                      marginRight: 20,
                    }}
                  />
                ) : (
                  <>
                    <img
                      src="https://static.vecteezy.com/system/resources/thumbnails/009/292/244/small/default-avatar-icon-of-social-media-user-vector.jpg"
                      style={{
                        height: 130,
                        width: 130,
                        marginLeft: 20,
                        borderRadius: 60,
                        marginRight: 20,
                      }}
                    />
                  </>
                )}
                <button className="upload-btn" onClick={clickImageData}>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={imagePicker}
                    style={{ display: "none" }}
                  />
                  Upload Image
                </button>
              </div>
              <button className="close-btn" onClick={() => navigate(-1)}>
                <img src={require("../../assest/Images/crossVector.png")} />
              </button>
            </div>

            <div className="provider-form">
              <div className="form_div">
                <Inputbox
                  label="Legal First Name"
                  placeholder="Enter First Name"
                  name="firstName"
                  register={register}
                  style={{
                    backgroundColor: "#D9D9D9",
                    borderColor: errors.firstName ? "red" : "initial",
                  }}
                  lebalstyle={{ color: "white" }}
                />
                {errors.firstName && (
                  <div className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.firstName.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="Legal Last Name"
                  placeholder="Enter Last Name"
                  name="lastName"
                  register={register}
                  lebalstyle={{ color: "white" }}
                  style={{
                    borderColor: errors.lastName ? "red" : "initial",
                    backgroundColor: "#D9D9D9",
                  }}
                />
                {errors.lastName && (
                  <div className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.lastName.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="Email Address"
                  placeholder="Enter email address"
                  name="email"
                  register={register}
                  lebalstyle={{ color: "white" }}
                  style={{
                    borderColor: errors.email ? "red" : "initial",
                    backgroundColor: "#D9D9D9",
                  }}
                />
                {errors.email && (
                  <div className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.email.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="Phone Number"
                  placeholder="Enter phone number"
                  name="phone"
                  onChange={handleChange}
                  lebalstyle={{ color: "white" }}
                  style={{
                    borderColor: errors.phone ? "red" : "initial",
                    width: "100%",
                    backgroundColor: "#D9D9D9",
                    height: 43,
                  }}
                />
                {errors.phone && (
                  <p className="errorMessage">{errors.phone.message}</p>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustom
                  label="Gender"
                  placeholder="Select Gender"
                  options={[
                    { _id: "Male", name: "Male" },
                    { _id: "Female", name: "Female" },
                    { _id: "Other", name: "Other" },
                  ]}
                  name="gender"
                  register={register}
                  clearErrors={clearErrors}
                  lebalstyle={{ color: "white" }}
                  style={{
                    borderColor: errors.gender ? "red" : "initial",
                    backgroundColor: "#D9D9D9",
                  }}
                />
                {errors.gender && (
                  <p className="errorMessage">{errors.gender.message}</p>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="Date of Birth"
                  type="date"
                  lebalstyle={{ color: "white" }}
                  name="DOB"
                  register={register}
                  style={{
                    borderColor: errors.DOB ? "red" : "initial",
                    backgroundColor: "#D9D9D9",
                  }}
                />
                {errors.DOB && (
                  <p className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.DOB.message}
                  </p>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustom
                  label="Experience (Years)"
                  placeholder="Select option"
                  options={options}
                  name="experience"
                  dropdownicon
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  lebalstyle={{ color: "white" }}
                  style={{
                    backgroundColor: "#D9D9D9",
                  }}
                />
                {errors.experience && (
                  <p className="errorMessage">{errors.experience.message}</p>
                )}
              </div>
              <div className="form_div">
                <Autocomplete
                  onLoad={(autocompleteInstance) =>
                    setAddressAutocomplete(autocompleteInstance)
                  }
                  onPlaceChanged={handleAddressSelection}
                >
                  <Inputbox
                    label="Provider Home Address"
                    type="text"
                    placeholder="Enter Provider Home Address"
                    name="ProviderHomeAddress"
                    register={register}
                    lebalstyle={{ color: "white" }}
                    style={{
                      backgroundColor: "#D9D9D9",
                    }}
                  />
                </Autocomplete>
                {errors.ProviderHomeAddress && (
                  <p className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.ProviderHomeAddress.message}
                  </p>
                )}
              </div>

              <div className="form_div" style={{ marginTop: 5 }}>
                <DropDownManuCustom
                  label="Provider Primary Pratice Address"
                  placeholder="Select Practice Location"
                  options={servicelocation}
                  name="ServiceLocationId"
                  dropdownicon
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  lebalstyle={{ color: "white" }}
                  style={{
                    backgroundColor: "#D9D9D9",
                  }}
                />
                {errors.ServiceLocationId && (
                  <div className="errorMessage">
                    {errors.ServiceLocationId.message}
                  </div>
                )}
              </div>
              <div className="form_div" style={{ marginTop: -10 }}>
                <lable
                  style={{
                    display: "flex",
                    marginBottom: -10,
                    color: "white",
                    fontSize: "16px",
                    fontWeight: "600",
                    marginTop: 30,
                  }}
                >
                  Available Days
                </lable>
                <div
                  className="Available_Days_divv"
                  onClick={handleavailibledays}
                  style={{ marginTop: 20, backgroundColor: "#D9D9D9" }}
                >
                  <div
                    style={{
                      backgroundColor: "#D9D9D9",
                    }}
                  >
                    {" "}
                    {availableDays &&
                    availableDays.length > 0 ? (
                      <div className="selected-days">
                        {availableDays
                          .slice(0, 2)
                          .map((e) => e.day)
                          .join(", ")}
                        {availableDays.length > 2 && " ..."}
                      </div>
                    ) : (
                      "Available Days"
                    )}
                  </div>
                  <Dropdowniconn />
                </div>
              </div>
              <div className="form_div">
                <Inputbox
                  label="Provider NPI"
                  placeholder="Enter NPI"
                  name="ProviderNPI"
                  register={register}
                  style={{
                    borderColor: errors.ProviderNPI ? "red" : "initial",
                    backgroundColor: "#D9D9D9",
                  }}
                  lebalstyle={{ color: "white" }}
                />
                {errors.ProviderNPI && (
                  <div className="errorMessage" style={{ marginTop: -15 }}>
                    {" "}
                    {errors.ProviderNPI.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustom
                  label="Associated with"
                  placeholder="Select option"
                  options={cliniclistdata}
                  name="agencyId"
                  dropdownicon
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  disabled={true}
                  defaultValue={profiledata._id}
                  style={{
                    backgroundColor: "#D9D9D9",
                  }}
                  lebalstyle={{ color: "white" }}
                />
                {errors.AssociationRequest && (
                  <span className="errorMessage">
                    {errors.AssociationRequest.message}
                  </span>
                )}
              </div>
              <div className="form_div">
                <Autocomplete
                  onLoad={(autocompleteInstance) =>
                    setAutocomplete(autocompleteInstance)
                  }
                  onPlaceChanged={handlePlaceSelect}
                >
                  <Inputbox
                    label="Street"
                    type="text"
                    placeholder="Enter Address"
                    name="address.street"
                    register={register}
                    style={{
                      backgroundColor: "#D9D9D9",
                    }}
                    lebalstyle={{ color: "white" }}
                  />
                </Autocomplete>
              </div>
              <div className="form_div">
                <Inputbox
                  label="City"
                  type="text"
                  placeholder="Enter City"
                  name="address.city"
                  register={register}
                  style={{
                    backgroundColor: "#D9D9D9",
                  }}
                  lebalstyle={{ color: "white" }}
                />
                {errors.address?.city && (
                  <div className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.address.city.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="State"
                  type="text"
                  placeholder="Enter State"
                  name="address.state"
                  register={register}
                  style={{
                    backgroundColor: "#D9D9D9",
                  }}
                  lebalstyle={{ color: "white" }}
                />
                {errors.address?.state && (
                  <div className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.address.state.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="Country"
                  type="text"
                  placeholder="Enter Country"
                  name="address.country"
                  register={register}
                  style={{
                    backgroundColor: "#D9D9D9",
                  }}
                  lebalstyle={{ color: "white" }}
                />
                {errors.address?.country && (
                  <div className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.address.country.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="Zip Code"
                  type="text"
                  placeholder="Enter Zip Code"
                  name="address.zipCode"
                  register={register}
                  style={{
                    backgroundColor: "#D9D9D9",
                  }}
                  lebalstyle={{ color: "white" }}
                />
                {errors.address?.zipCode && (
                  <div className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.address.zipCode.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <Inputbox
                  label="Short Biography"
                  placeholder="Enter Short Biography"
                  name="info"
                  register={register}
                  style={{
                    backgroundColor: "#D9D9D9",
                    borderColor: errors.info ? "red" : "initial",
                  }}
                  lebalstyle={{ color: "white" }}
                />
                {errors.info && (
                  <div className="errorMessage" style={{ marginTop: -15 }}>
                    {errors.info.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustom
                  label="Location Timezone"
                  placeholder="Select option"
                  options={Locationdata}
                  name="TimeZone"
                  dropdownicon
                  register={register}
                  id="name"
                  clearErrors={clearErrors}
                  lebalstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "white" }}
                />
                <p style={{ color: "red", textAlign: "left" }}>
                  {errors.TimeZone?.message}
                </p>
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Language"
                  placeholder="Select option"
                  options={data}
                  name="LanguagesId"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={handlelanguage}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                />
                {errors.LanguagesId && (
                  <p className="errorMessage">{errors.LanguagesId.message}</p>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Specialities"
                  placeholder="Select option"
                  options={specialtydata}
                  name="categoryId"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={handleSelect}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                />
                {errors.categoryId && (
                  <p className="errorMessage">{errors.categoryId.message}</p>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Specialties"
                  placeholder="Select option"
                  options={Specialties}
                  name="Specialties"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={selectSpecialties}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                />

                {errors.SpecialPopulationExpertise && (
                  <div className="errorMessage" style={{ marginTop: 5 }}>
                    {errors.SpecialPopulationExpertise.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Provider Type"
                  placeholder="Select option"
                  options={providerType}
                  name="ProviderType"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={handleSelectProviderType}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                />
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Condition Treated"
                  placeholder="Select option"
                  options={conditionTreated}
                  name="ConditionTreatedId"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={handleSelectConditionTreated}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                />
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Degree Type"
                  placeholder="Select option"
                  options={Degreetypedata}
                  name="degreeTypeId"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                  onSelect={handleSelectdegreetype}
                />
                {errors.degreeTypeId && (
                  <div className="errorMessage">
                    {errors.degreeTypeId.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Modalities (Treatment Approaches)"
                  placeholder="Select option"
                  options={Modalities}
                  name="Modalities"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={selectModalities}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                />

                {errors.Modalities && (
                  <div className="errorMessage">
                    {errors.Modalities.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Population (Ages Served)"
                  placeholder="Select option"
                  options={PopulationServed}
                  name="Population"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={selectPopulationServed}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                />

                {errors.Population && (
                  <div className="errorMessage">
                    {errors.Population.message}
                  </div>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Insurance Currently Accepted"
                  placeholder="Select option"
                  options={Insurance}
                  name="Insurance"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={selectInsurance}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                />

                {errors.Insurance && (
                  <div className="errorMessage">{errors.Insurance.message}</div>
                )}
              </div>
              <div className="form_div">
                <DropDownManuCustomMulti
                  label="Treatment Type (Service Type)"
                  placeholder="Select Treatment Type "
                  options={Treatment}
                  name="ServiceType"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  onSelect={selectTreatmentType}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                />

                {errors.ServiceType && (
                  <div className="errorMessage">
                    {errors.ServiceType.message}
                  </div>
                )}
              </div>
              <div className="form_div" style={{ marginTop: 25 }}>
                <DropDownManuCustomMulti
                  label="Delivery Mode"
                  placeholder="Select option"
                  options={deleveryMode}
                  name="DeliveryMode"
                  register={register}
                  id="_id"
                  clearErrors={clearErrors}
                  labelstyle={{ color: "white" }}
                  boxstyle={{ backgroundColor: "#D9D9D9" }}
                  onSelect={selectDeliveryMode}
                />
                {errors.DeliveryMode && (
                  <div className="errorMessage">
                    {errors.DeliveryMode.message}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="review-popup-buttons1" style={{ marginTop: 50 }}>
            <button
              className="review-cancel-btn1"
              style={{ height: 40 }}
              onClick={onClose}
            >
              Cancel
            </button>
            <button className="review-save-btn1" style={{ height: 40 }}>
              Save
            </button>
          </div>
        </div>
      </form>
      {showavailibleday && (
        <div id="settings-modal" className="modal_CalendarView">
          <div className="modal-content_CalendarView">
            <div className="close_CalendarView">
              <span onClick={() => setShowavailibleday(false)}>&times;</span>
            </div>
            <h2>Working Hours Settings</h2>
            <p>Configure your working hours and scheduling constraints.</p>

            <div id="settings-days-container" style={{ marginBottom: 20 }}>
              {days.map((day) => (
                <div key={day} className="day-row_CalendarView">
                  <div className="day-row-header_CalendarView">
                    <strong>{day}</strong>
                    <button
                      type="button"
                      className="add-block-btn_CalendarView"
                      onClick={() => addTimeBlock(day)}
                    >
                      Add Time Block
                    </button>
                  </div>
                  <div className="time-blocks_CalendarView">
                    {weeklySchedule[day].map((block, index) => (
                      <div key={index} className="time-block_CalendarView">
                        <label>Start:</label>
                        <input
                          type="time"
                          value={block.start}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "start",
                              e.target.value
                            )
                          }
                        />
                        <label>End:</label>
                        <input
                          type="time"
                          value={block.end}
                          onChange={(e) =>
                            handleTimeBlockChange(
                              day,
                              index,
                              "end",
                              e.target.value
                            )
                          }
                        />
                        <button
                          type="button"
                          className="remove-block-btn_CalendarView"
                          onClick={() => removeTimeBlock(day, index)}
                        >
                          Remove
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="button-container_CalendarView">
              <button
                type="button"
                className="save-settings-button_CalendarView"
                onClick={handleSaveSettings}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddProviderpopupagency;

const modalinsuranceStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  height: "80vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 4,
  outline: "none",
  zIndex: 999,
  overflowY: "auto",
};
